function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.0209 21.9791C27.1693 20.1276 24.9654 18.7569 22.5608 17.9272C25.1362 16.1534 26.8281 13.1848 26.8281 9.82812C26.8281 4.40891 22.4192 0 17 0C11.5808 0 7.17188 4.40891 7.17188 9.82812C7.17188 13.1848 8.86384 16.1534 11.4393 17.9272C9.0347 18.7569 6.83081 20.1276 4.97921 21.9791C1.76833 25.1901 0 29.4591 0 34H2.65625C2.65625 26.0908 9.09082 19.6562 17 19.6562C24.9092 19.6562 31.3438 26.0908 31.3438 34H34C34 29.4591 32.2317 25.1901 29.0209 21.9791ZM17 17C13.0454 17 9.82812 13.7828 9.82812 9.82812C9.82812 5.8735 13.0454 2.65625 17 2.65625C20.9546 2.65625 24.1719 5.8735 24.1719 9.82812C24.1719 13.7828 20.9546 17 17 17Z",
  fill: "white"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.68c084eb.svg";
export { ForwardRef as ReactComponent };